import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

const Footer = () => {
    return (
            <Toolbar sx={{ bgcolor: "#8B0E04",  color:'#f8f9fa',  marginTop: 'auto'}}>
                <Container sx={{textAlign:'center'}}>
                    <Typography sx={{ color:'#f8f9fa'}}>Copyright © {(new Date().getFullYear())} City of San Antonio</Typography>
                    <Typography>
                        <Link href="https://www.sanantonio.gov/dao" target="_blank" sx={{ color:'#f8f9fa', display: 'inline-block' }} >{'ADA Compliance'} </Link>
                        <Typography sx={{display: 'inline-block', color:'#f8f9fa'}}>&nbsp; | &nbsp;</Typography>
                        <Link href="https://www.sa.gov/Disclaimer" target="_blank" sx={{ color:'#f8f9fa' , display: 'inline-block'}} >{'Privacy Policy & Disclaimer'} </Link>
                        {/* <Typography sx={{display: 'inline-block'}}>&nbsp; | &nbsp;</Typography>
                        <Link href="https://www.sa.gov/Site-Footer/Contact-Us" target="_blank" sx={{ color:'white', display: 'inline-block' }} >{'Contact Us'}</Link> */}
                    </Typography>
                    <Typography>
                        <Typography sx={{display: 'inline-block',color:'#f8f9fa'}}>If you require assistance, language translation, or wish to report an issue related to accessibility, please contact&nbsp;210-207-6369</Typography>
                        <Link href="mailto:cao.outsidecounsel@sanantonio.gov" sx={{ color:'#f8f9fa', display: 'inline-block'}} >cao.outsidecounsel@sanantonio.gov</Link>
                    </Typography>
                </Container>
            </Toolbar>
    );
};

export default Footer;